import ReactGA from "react-ga";

/**
 *忘记密码按钮点击
 * @param {string} label
 */
const GAForgotPasswordBtnClick = label => {
  ReactGA.event(
    {
      category: "forgot_password",
      action: "forgot_click",
      label,
    },
    ["OnlineTracker", "Tracker"]
  );
};

/**
 * 忘记密码获取验证码按钮点击
 */
const GAForgotPasswordClickGetCode = () => {
  ReactGA.event(
    {
      category: "forgot_password",
      action: "forgot_code_click",
    },
    ["OnlineTracker", "Tracker"]
  );
};

/**
 * 忘记密码点击提交按钮
 */
const GAForgotPasswordClickConfirm = () => {
  ReactGA.event(
    {
      category: "forgot_password",
      action: "verify_click",
    },
    ["OnlineTracker", "Tracker"]
  );
};

export { GAForgotPasswordBtnClick, GAForgotPasswordClickGetCode, GAForgotPasswordClickConfirm };
